import { render, staticRenderFns } from "./ProductDetails2.vue?vue&type=template&id=3f182f49&scoped=true"
import script from "./ProductDetails2.vue?vue&type=script&lang=js"
export * from "./ProductDetails2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f182f49",
  null
  
)

export default component.exports